import { Action } from 'redux';

import { isUpdateBreadcrumbHrefAction } from '../actions/UpdateBreadcrumbHref';
import { isUpdateBreadcrumbsAction } from '../actions/UpdateBreadcrumbsAction';
import { BreadcrumbsState } from '../state/BreadcrumbsState';

const initialState: BreadcrumbsState = [];

export function breadcrumbsReducer(
  breadcrumbs: BreadcrumbsState = initialState,
  action: Action = null
): BreadcrumbsState {
  if (isUpdateBreadcrumbsAction(action)) {
    return action.breadcrumbs.map((newBreadcrumb, i) => {
      if (breadcrumbs.length < i + 1 || !breadcrumbs[i].id || breadcrumbs[i].id !== newBreadcrumb.id) {
        return newBreadcrumb;
      }
      return { ...newBreadcrumb, href: breadcrumbs[i].href };
    });
  } else if (isUpdateBreadcrumbHrefAction(action)) {
    return breadcrumbs.map((breadcrumb, index) => {
      if (index + 1 === breadcrumbs.length) {
        return { ...breadcrumb, href: action.href };
      }
      return breadcrumb;
    });
  }

  return breadcrumbs;
}
